import { Logo, cn } from '@clickt/brand';

/** Theme-paired lockup: dark-text in light mode, white-text in dark mode. */
export function ThemedLogo({ className }: { className?: string }) {
  return (
    <>
      <Logo className={cn(className, 'dark:hidden')} />
      <Logo variant="lockup-light" className={cn(className, 'hidden dark:block')} />
    </>
  );
}
